import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/trello': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M392.3 32c30.8 0.2 55.7 25.2 55.6 56v336c0 30.8-24.9 55.8-55.7 56h-336.2c-30.9 0-56-25.1-56-56 0-340-0.1-336 0-336 0-30.9 25.1-56 56.1-56h336.2zM197 371.3h0.1v-254.2c0-14.9-12.1-26.9-26.9-26.9h-82.9c-14.9 0-26.9 12.1-26.9 26.9v254.2c0.1 14.8 12.2 26.7 27 26.6h82.7c14.8 0 26.7-11.9 26.9-26.6zM390.1 259.3v-142.1c0-14.9-12.1-26.9-26.9-26.9h-81.1c-14.8 0-26.8 12.1-26.8 26.9v142.1c0 14.9 12.1 26.9 26.9 26.9h81c14.9 0 26.9-12.1 26.9-26.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/trello.js
// module id = 1058
// module chunks = 0